import React, { Fragment } from "react";
import AppleIcon from "./../assets/social/apple.svg";
import GoogleIcon from "./../assets/social/google.svg";
import SpotifyIcon from "./../assets/social/spotify.svg";
import AnchorIcon from "./../assets/social/anchor.svg";

const LatestPodcastCard = ({
  title,
  description,
  applePodcastUrl,
  googlePodcastUrl,
  spotifyPodcastUrl,
  anchorPodcastUrl,
  imageUrl,
}) => {
  return (
    <Fragment>
      <div className="bg-white p-4 lg:px-12 lg:py-8 mt-16 myShadow flex justify-between flex-col-reverse lg:flex-row rounded-xl w-full lg:w-10/12 m-auto">
        <div className="w-full lg:w-1/2 mt-5">
          <p className="text-xs font-semibold">Latest Episode</p>
          <h3 className="font-bold text-2xl mt-4">{title}</h3>
          <p className="text-justify mt-4">{description}</p>
          <div className="flex gap-2 mt-8">
            <p className="text-blue italic text-sm">
              Available on these podcast platforms ⬇️
            </p>
          </div>
          <div className="flex justify-between">
            <div className="flex gap-[-4px]">
              <a href={applePodcastUrl} target="_blank" rel="noreferrer">
                <img src={AppleIcon} alt="Apple Icon" />
              </a>
              <a href={googlePodcastUrl} target="_blank" rel="noreferrer">
                <img src={GoogleIcon} alt="Google Icon" />
              </a>
              <a href={spotifyPodcastUrl} target="_blank" rel="noreferrer">
                <img src={SpotifyIcon} alt="Spotify Icon" />
              </a>
              <a href={anchorPodcastUrl} target="_blank" rel="noreferrer">
                <img src={AnchorIcon} alt="Anchor Icon" />
              </a>
            </div>
          </div>
        </div>
        <div className="">
          <img
            src={imageUrl}
            alt="Latest Sermon Poster"
            className="h-[350px] w-[420px] rounded-xl shadow-lg"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default LatestPodcastCard;
